import React from "react";
import { Link } from "react-router-dom";
import LayoutMain from "../../components/Layout/Main/Main";
import { getDataServicePage } from "../../Data/Service";
import LeftSidedImageCopyItemCollection from "../../Partials/LeftSidedImageCopyItem/collection";
import ServiceItemCollection from "../../Partials/ServiceItem/Collection";

const leftSidedImageCopyItemCollectionData = [
  {
    description: [
      "Our greatest strength is our ability to deliver a comprehensive and considered service. From the initial design stages through construction and into ongoing maintenance, our workmanship is guaranteed at every stage of the process.",
    ],
    descriptionContent: (
      <>
        <div id="accordion" className="services-accordion">
          <div className="card">
            <div className="card-header" id="heading-1">
              <h5 className="mb-0">
                <button
                  className="btn btn-link"
                  data-toggle="collapse"
                  data-target="#collapse-1"
                  aria-expanded="true"
                  aria-controls="collapse-1"
                >
                  Consultation
                </button>
              </h5>
            </div>
            <div
              id="collapse-1"
              className="collapse show"
              aria-labelledby="heading-1"
              data-parent="#accordion"
            >
              <div className="card-body">
                <p>
                  {" "}
                  As each garden has its own characteristics to work with we
                  meet onsite to gain an understanding of your requirements
                  specific to the site and in conjunction with a short
                  questionnaire we develop a brief for your garden area.
                </p>
                <p>
                  Conceptual ideas for the space are discussed along with ideas
                  on material selection. Inspirations from our extensive
                  portfolio of work are discussed and we explore how they can be
                  applied to your home.
                </p>
                <p>
                  Following the site consultation a proposal for the following
                  services will be forwarded for your consideration.
                </p>{" "}
                <p>
                  Alternatively you can call or email us on the details below.
                  <br />
                  (02) 9380 7957 <br />
                  imagine@thinkoutsidegardens.com.au
                </p>
                <p>
                  <Link to="/consultation" className="link-more">
                    Read More
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="heading-2">
              <h5 className="mb-0">
                <button
                  className="btn btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapse-2"
                  aria-expanded="true"
                  aria-controls="collapse-2"
                >
                  Design
                </button>
              </h5>
            </div>
            <div
              id="collapse-2"
              className="collapse"
              aria-labelledby="heading-2"
              data-parent="#accordion"
            >
              <div className="card-body">
                <p>
                  The Garden design stage is the detailing and development of
                  the ideas discussed on-site into a design concept plan
                  providing an overall image of the finished garden. Included is
                  a plan view of the project, perspective sketches of key areas,
                  material suggestions such as paving or tiling elements and
                  finally suggestions for plant material. Each garden design
                  concept package includes sample images of the proposed works
                  and an estimate of cost to implement the design.
                </p>
                <p>
                  <Link to="/design" className="link-more">
                    Read More
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="heading-3">
              <h5 className="mb-0">
                <button
                  className="btn btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapse-3"
                  aria-expanded="true"
                  aria-controls="collapse-3"
                >
                  Estimating
                </button>
              </h5>
            </div>
            <div
              id="collapse-3"
              className="collapse"
              aria-labelledby="heading-3"
              data-parent="#accordion"
            >
              <div className="card-body">
                <p>
                  If the proposed scope of works requires an Application to
                  council, a qualified and experienced Landscape Architect will
                  document the concept plans for construction and prepare the
                  supporting documentation. A detailed quote with options is
                  then prepared for your consideration.
                </p>
                <p>
                  <Link to="/estimating" className="link-more">
                    Read More
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="heading-4">
              <h5 className="mb-0">
                <button
                  className="btn btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapse-4"
                  aria-expanded="true"
                  aria-controls="collapse-4"
                >
                  Construction
                </button>
              </h5>
            </div>
            <div
              id="collapse-4"
              className="collapse"
              aria-labelledby="heading-4"
              data-parent="#accordion"
            >
              <div className="card-body">
                <p>
                  Think Outside Gardens trusted and personalised service is
                  delivered through consistency and a thorough knowledge of the
                  product. Our team of skilled and experienced landscapers and
                  horticulturalists work closely with the contractors we have
                  developed relationships with over many years.
                </p>
                <p>
                  In addition to meeting relevant Australian building standards
                  and statutory requirements Think Outside Gardens strives for
                  principles of best practice through industry associations.
                  Think Outside Gardens construction service is offered in
                  conjunction with or independently of the design service.
                </p>
                <p>
                  <Link to="/construction" className="link-more">
                    Read More
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="heading-5">
              <h5 className="mb-0">
                <button
                  className="btn btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapse-5"
                  aria-expanded="true"
                  aria-controls="collapse-5"
                >
                  Ongoing Maintenance
                </button>
              </h5>
            </div>
            <div
              id="collapse-5"
              className="collapse"
              aria-labelledby="heading-5"
              data-parent="#accordion"
            >
              <div className="card-body">
                <p>
                  Think Outside gardens provides an ongoing garden maintenance
                  service at regular intervals to provide year round piece of
                  mind. On-going maintenance programs are tailored to your
                  specific garden needs to manage pest and disease control, weed
                  management and optimising growth.
                </p>
                <p>
                  <Link to="/maintenance" className="link-more">
                    Read More
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    ),
    image : 'images/services.jpg',
    title : 'Services'
  },
  
];

const Services = () => {
  return (
    <LayoutMain>
    <section className="about-top">
<div className="container-3">
  <LeftSidedImageCopyItemCollection data={leftSidedImageCopyItemCollectionData} />
</div>
</section>

      <section className="pt-115 pb-120 pt-sm-30 pb-sm-40">
        <div className="container-3">
          <div className="row">
            <ServiceItemCollection data={getDataServicePage} />
          </div>
        </div>
      </section>
    </LayoutMain>
  );
};

export default Services;
